import React from 'react'
import * as S from './Footer.styles'
import ValeLogo from 'assets/images/logo-vale-white.png'
import { useIntl } from 'gatsby-plugin-intl'
import policyPT from 'assets/docs/POLITICA_PRIVACIDADE_-_VALE_-_Encontro_de_Especialistas.pdf'
import policyEN from 'assets/docs/v-tm_-POLITICA-PRIVACIDADE-VALE-VPS-Summit-People-at-the-core-20210524_ENG.pdf'
import termsPT from 'assets/docs/TERMOS_DE_USO-_VALE_-_Encontro_de_Especialistas.pdf'
import termsEN from 'assets/docs/v-tm_-TERMOS-DE-USO-VALE-VPS-Summit-People-at-the-core-20210524_ENG.pdf'

const Footer = () => {
  const { formatMessage, locale } = useIntl()

  const policyLanguage = {
    pt: policyPT,
    en: policyEN
  }

  const termsLanguage = {
    pt: termsPT,
    en: termsEN
  }

  return (
    <S.Footer id="footer">
      <S.Wrapper>
        <S.Content>
          <S.ImageWrapper>
            <S.LogoVale src={ValeLogo} alt="logo da Vale" />
          </S.ImageWrapper>
          <S.Subtitle>{formatMessage({ id: 'footer.subtitle' })}</S.Subtitle>
          <S.Text target="_blank" href="mailto:contato@vpsvale.com">
            {formatMessage({ id: 'footer.email' })}
          </S.Text>
          <S.ButtonsGroup>
            <S.ButtonInfo target="_blank" href={termsLanguage[locale]}>
              {formatMessage({ id: 'footer.link-1' })}
            </S.ButtonInfo>
            /
            <S.ButtonInfo target="_blank" href={policyLanguage[locale]}>
              {formatMessage({ id: 'footer.link-2' })}
            </S.ButtonInfo>
          </S.ButtonsGroup>
        </S.Content>
      </S.Wrapper>
    </S.Footer>
  )
}

export default Footer
